import type { VariantProps } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
import * as React from 'react';
import mergeClasses from 'shared/lib/utils';
import type { buttonVariants } from './button';
import { Button } from './button';
import { TooltipWrapper } from 'shared/ui/tooltips';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  loading: boolean;
  withText?: boolean;
  loaderSize?: string;
  toolTipContent?: string;
}
export function LoadingButton({
  loading,
  loaderSize,
  toolTipContent,
  withText,
  ...props
}: ButtonProps) {
  if (toolTipContent) return <TooltipWrapper content={toolTipContent}>
        <Button disabled={loading} {...props}>
          {loading ? <Loader2 className={mergeClasses('h-4 w-4 animate-spin', loaderSize)} /> : <span>{props.children}</span>}
        </Button>
      </TooltipWrapper>;
  return <Button disabled={loading || props.disabled} {...props} data-sentry-element="Button" data-sentry-component="LoadingButton" data-sentry-source-file="loading-button.tsx">
      {loading ? withText ? <div className="space-x-1.5 flex items-center">
            <span>{props.children}</span>
            <Loader2 className={mergeClasses('h-4 w-4 animate-spin', loaderSize)} />
          </div> : <Loader2 className={mergeClasses('h-4 w-4 animate-spin', loaderSize)} /> : <span>{props.children}</span>}
    </Button>;
}